import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { apiAdmin, TOKEN_STORAGE_KEY } from './api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        try {
            const raw = localStorage.getItem('zz_admin_user');
            return raw ? JSON.parse(raw) : null;
        } catch (_) { return null; }
    });
    const [token, setToken] = useState(() => localStorage.getItem(TOKEN_STORAGE_KEY) || null);
    const [bootstrapped, setBootstrapped] = useState(false);

    // Verify token validity on mount
    useEffect(() => {
        let mounted = true;
        const verify = async () => {
            if (!token) { setBootstrapped(true); return; }
            try {
                const r = await apiAdmin.get('/auth/me');
                if (!mounted) return;
                setUser(r.data);
                localStorage.setItem('zz_admin_user', JSON.stringify(r.data));
            } catch (_) {
                if (!mounted) return;
                setUser(null); setToken(null);
                localStorage.removeItem(TOKEN_STORAGE_KEY);
                localStorage.removeItem('zz_admin_user');
            }
            if (mounted) setBootstrapped(true);
        };
        verify();
        return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const login = useCallback(async (email, password) => {
        const r = await apiAdmin.post('/auth/login', { email, password });
        const { access_token, user: u } = r.data;
        localStorage.setItem(TOKEN_STORAGE_KEY, access_token);
        localStorage.setItem('zz_admin_user', JSON.stringify(u));
        setToken(access_token);
        setUser(u);
        return u;
    }, []);

    const logout = useCallback(async () => {
        try { await apiAdmin.post('/auth/logout'); } catch (_) { /* noop */ }
        localStorage.removeItem(TOKEN_STORAGE_KEY);
        localStorage.removeItem('zz_admin_user');
        setToken(null); setUser(null);
    }, []);

    return (
        <AuthContext.Provider value={{ user, token, bootstrapped, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error('useAuth must be inside AuthProvider');
    return ctx;
};
